"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.parse-int.js");

var _dom = require("element-ui/lib/utils/dom");

var getReference = function getReference(vnode) {
  var tooltip = vnode.context.$root.tooltip;

  if (!tooltip || tooltip.$refs && !tooltip.$refs.popper) {
    return console.warn("[v-tooltip]: Trying to show the tooltip called \"".concat(tooltip, "\" that is not on the page. Make sure it is set in the APP DOM."));
  }

  return tooltip;
};

var handleTooltip = function handleTooltip(el, binding, tooltip) {
  if (!tooltip) {
    return;
  }

  var overflow = !!binding.modifiers.overflow;
  var range = document.createRange();
  range.setStart(el, 0);
  range.setEnd(el, el.childNodes.length);
  var rangeWidth = range.getBoundingClientRect().width;
  var padding = (parseInt((0, _dom.getStyle)(el, 'paddingLeft'), 10) || 0) + (parseInt((0, _dom.getStyle)(el, 'paddingRight'), 10) || 0);

  if (!overflow || overflow && (rangeWidth + padding > el.offsetWidth || el.scrollWidth > el.offsetWidth)) {
    var tooltipContent = binding.expression ? binding.value.content : binding.arg || el.innerText || el.innerHTML;
    var popperContainer = tooltip.$refs.popper.childNodes[0];

    if (tooltip.dangerouslyUseHTMLString) {
      popperContainer.innerHTML = tooltipContent.outerHTML || tooltipContent;
    } else {
      popperContainer.textContent = tooltipContent.outerHTML || tooltipContent;
      popperContainer.innerText = tooltipContent.outerHTML || tooltipContent;
    }

    tooltip.referenceElm = el;
    tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
    tooltip.doDestroy(); // tooltip.show();

    tooltip.setExpectedState(true);
    tooltip.handleShowPopper();
  }
};

var handleMouseEnter = function handleMouseEnter(el, binding, tooltip) {
  return function ($event) {
    handleTooltip(el, binding, tooltip);
    $event.stopPropagation();
  };
};

var handleMouseLeave = function handleMouseLeave(tooltip) {
  return function () {
    if (!tooltip) {
      return;
    } // tooltip.hide();


    tooltip.setExpectedState(false);
    tooltip.handleClosePopper();
  };
};

var _default = {
  inserted: function inserted(el, binding, vnode) {
    var tooltip = getReference(vnode);
    (0, _dom.on)(el, 'mouseleave', handleMouseLeave(tooltip));
    (0, _dom.on)(el, 'mouseenter', handleMouseEnter(el, binding, tooltip));
  },
  update: function update(el, binding, vnode) {
    if (binding.expression && binding.oldValue.content !== binding.value.content) {
      var tooltip = getReference(vnode);
      (0, _dom.off)(el, 'mouseleave', handleMouseLeave);
      (0, _dom.off)(el, 'mouseenter', handleMouseEnter);
      (0, _dom.on)(el, 'mouseleave', handleMouseLeave(tooltip));
      (0, _dom.on)(el, 'mouseenter', handleMouseEnter(el, binding, tooltip));
    }
  },
  unbind: function unbind(el, binding, vnode) {
    (0, _dom.off)(el, 'mouseleave', handleMouseLeave);
    (0, _dom.off)(el, 'mouseenter', handleMouseEnter);
  }
};
exports["default"] = _default;